const padNumber = (n?: number, number?: number) =>
  n &&
  n.toLocaleString('en-US', {
    minimumIntegerDigits: number,
    useGrouping: false,
  })

export default padNumber
